import React from 'react';
import cx from 'classnames';

import styles from '~/components/inputs/checkboxes.module.scss';
import inputStyles from '~/components/inputs/inputs.module.scss';

const RadioGroupField = ({
  label,
  input,
  meta,
  className,
  subLabel,
  variant,
}) => {
  const hasError = meta.submitFailed && meta.error;
  const { options, checked: _unused, ...otherInputProps } = input;

  const styledContainerClasses = cx(className, {
    [styles.radioGroup]: !variant,
    [styles.quizRadioGroup]: variant === 'quizForm',
  });

  const styledRadioClasses = cx(styles.round, {
    [styles.styledInput]: !variant,
    [styles.quizInput]: ['quizForm', 'zipcodeLawnSize'].includes(variant),
    [styles.error]: hasError,
  });

  return (
    <div className={styledContainerClasses}>
      <p
        className={cx({
          [inputStyles.label]: !variant,
          [inputStyles.quizLabel]: variant === 'quizForm',
        })}
      >
        {label}
      </p>

      {subLabel && (
        <p
          className={cx({
            [inputStyles.subLabel]: !variant,
            [inputStyles.quizSubLabel]: variant === 'quizForm',
          })}
        >
          {subLabel}
        </p>
      )}

      <div
        className={cx({
          [styles.quizOptionsContainer]: variant === 'quizForm',
        })}
      >
        {hasError && <p className={styles.error}>{meta.error}</p>}

        {options.map((option) => (
          <div key={option.value}>
            <label
              htmlFor={`${label}-${option.label}`}
              className={styles.wrapper}
            >
              <input
                {...otherInputProps}
                className={styles.input}
                id={`${label}-${option.label}`}
                type="radio"
                value={option.value}
                checked={String(input.value) === String(option.value)}
              />
              <span className={styledRadioClasses} />

              <div
                className={cx(styles.labelWrapper, {
                  [styles.active]:
                    ['quizForm', 'zipcodeLawnSize'].includes(variant) &&
                    String(input.value) === String(option.value),
                })}
              >
                {/* Very specific to Lawn Quiz - Adds this banner for the "Liquid" answer in the Liquid vs Granular questions */}
                {option.value === 'liquid' && (
                  <div className={styles.recommendedLabel}>
                    Recommended for your lawn
                  </div>
                )}

                <p
                  className={cx({ [styles.radioLabelLarge]: option.subLabel })}
                >
                  {option.label}
                </p>
                {option.subLabel && <p>{option.subLabel}</p>}
              </div>
            </label>
            {option.content && (
              <div className={styles.radioGroupContent}>{option.content}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RadioGroupField;
